var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpPcTourIconYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92834 10.5581L5.80808 6.79867C5.82651 6.76182 5.8791 6.76182 5.89752 6.79867L7.77726 10.5581C7.79938 10.6024 7.75068 10.6485 7.70773 10.6239L5.87761 9.57813C5.86224 9.56935 5.84337 9.56935 5.82799 9.57813L3.99787 10.6239C3.95492 10.6485 3.90622 10.6024 3.92834 10.5581Z",
    stroke: "#EB662B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7061 9.56418L8.42227 1",
    stroke: "#EB662B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.56418L3.28378 1",
    stroke: "#EB662B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85303 4.99687V3.85498",
    stroke: "#EB662B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85303 2.14189V1",
    stroke: "#EB662B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpPcTourIconYellow);
export default __webpack_public_path__ + "static/media/cp-pc-tour-icon-yellow.95f878fca30d349fb6f3e9f75d15eb42.svg";
export { ForwardRef as ReactComponent };